import React, { Component } from "react";
import "./app.scss";
import HeaderComponent from "views/main/header/header.component";
import BodyComponent from "views/main/body/body.component";
import FooterComponent from "views/main/footer/footer.component";
import MarginRightComponent from "views/main/margin-right/margin-right.component";
import { TypedConnect } from "models/store";
import { initialize } from "./models/actions/initialize.action";
import { IAuthenticationState } from "sthinds.io-lib";
import { ApolloClient } from "@apollo/client";

interface IAppComponentProps {
  dispatch: (action: unknown) => void;
  client?: ApolloClient;
  authentication?: IAuthenticationState;
}

interface IAppComponentState {}

/**
 * Map Redux state values to component props
 */
const mapStateToProps = (state: IAppComponentState) => {
  return {};
};

const mapDispatchToProps = (dispatch: unknown) => {
  return {
    dispatch,
  };
};

/**
 * connect() allows components to connect to the global redux datastore
 *  - can map properties from store state to component props
 */
@TypedConnect(mapStateToProps, mapDispatchToProps)
export default class App extends Component<
  IAppComponentProps,
  IAppComponentState
> {
  componentDidMount() {
    document.title = "sthinds.io";
  }

  constructor(public props: IAppComponentProps) {
    super(props);
    /**
     * on instantiation, load cached state (stored in browser localStorage)
     */
    this.loadStateFromLocalStorage();
  }

  /**
   * load cached state from browser localStorage
   *  - this allows persistent state across page reloads
   */
  private loadStateFromLocalStorage(): void {
    const cachedState = localStorage.getItem("appState");
    if (cachedState === null) {
      return undefined;
    }
    /**
     * dispatch an initialization action to the store
     *  - passed through reducers to generate initial state
     */
    this.props.dispatch(initialize(JSON.parse(cachedState)));
  }

  /**
   * One layout for every width. The top bar spans the viewport, the reading
   * column and the post index sit side by side below it, and the index drops
   * beneath the article once the grid runs out of room (see app.scss).
   */
  render() {
    return (
      <div className="App">
        <HeaderComponent client={this.props.client} />
        <div className="app-shell">
          <main className="reading-column">
            <BodyComponent></BodyComponent>
            <FooterComponent></FooterComponent>
          </main>
          <MarginRightComponent></MarginRightComponent>
        </div>
      </div>
    );
  }
}
